export default "__VITE_ASSET__lmbNxumD__"